export const messageType = {
  ERROR: 'Error: ',
  UPDATE_OK: 'Actualización correcta',
  FILE_UPLOAD_OK: 'Archivo subido correctamente',
  FILE_DOWNLOAD: 'Archivo descargado',
};

export type MessageType = keyof typeof messageType;
